import { render } from "./App.vue?vue&type=template&id=d6cdd256"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d6cdd256&lang=css"
script.render = render

export default script